var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@material-ui/core/styles';
import { compose, shadows } from '@material-ui/system';
import MuiAlert from '@material-ui/lab/Alert';
import { AttentionFilledIcon, InfoFilledIcon, WarningFilledIcon, } from '../Icon';
var StyledAlert = styled(MuiAlert)(compose(shadows));
/**
 * Kareo wrapped component of the Material-UI Alert. The prop API has been limited to props defined in AlertProps.
 *
 * An alert displays a short, important message in a way that attracts the user's attention without interrupting the user's task.
 *
 * In comparison to Snackbar which responds to user actions, Alert is inline with page content and can persist.
 * The darker Alert ("filled" variant) is displayed sitewide, and the lighter inline Alert ("standard" variant) is more commonly
 * used throughout the application.
 *
 * Material-UI Alert: [Docs](https://v4.mui.com/components/alert/), [API](https://v4.mui.com/api/alert/)
 *
 * @storybook: [Alert](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-alert--alert-main)
 */
var Alert = React.forwardRef(function (_a, ref) {
    var variant = _a.variant, props = __rest(_a, ["variant"]);
    return (React.createElement(StyledAlert, __assign({}, props, { ref: ref, variant: variant, boxShadow: variant === 'filled' ? 3 : 0, iconMapping: {
            error: React.createElement(AttentionFilledIcon, { fontSize: "smaller" }),
            info: React.createElement(InfoFilledIcon, { fontSize: "smaller" }),
            warning: React.createElement(WarningFilledIcon, { fontSize: "smaller" }),
        } })));
});
Alert.defaultProps = { severity: 'info' };
Alert.displayName = 'KareoAlert';
export default Alert;
